module.exports = __webpack_public_path__ + "img/chinesecompany34.79b8a597.png";